module.exports = __webpack_public_path__ + "img/性别认证.52902031.png";